import React from 'react'
import { Link } from 'react-router-dom'
import { useModal } from '../../contexts/ModalContext';

export default function RoomBook({roomBook}) {
    const { openQueryModal } = useModal();

  return (
    <>
    <section className="roomdetail-book">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-7 col-md-9">
                    <h3 className="heading center-heading">{roomBook.location} - {roomBook.title}</h3>
                    <p>{roomBook.desc}</p>
                    <ul>
                        {roomBook.details.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    <Link onClick={openQueryModal} className='default-btn color-btn'>Enquire Now</Link>
                    <a href={roomBook.bookLink} target='_blank' rel="noreferrer" className='default-btn'>Book Now</a>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
